import { View } from "@/components/ui";
import { useParams } from "@/components/hooks/use-params";
import { Navigate } from "react-router-dom";

import { PaymentMethodContainer } from "@/containers/profile/invoices/payment-method";
import { InvoiceDetailContainer } from "@/containers/profile/invoices/invoice-detail/InvoiceDetail.container";

export function InvoiceDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/profile/invoices" />;
  }

  return (
    <View>
      <InvoiceDetailContainer invoiceId={id} />
      <PaymentMethodContainer />
    </View>
  );
}
